import React from 'react';

const Card = ({ 
  children,
  title,
  description,
  header,
  footer,
  className = '',
  padding = 'md',
  shadow = true,
  border = true,
  onClick,
  hoverable = false
}) => {
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
    xl: 'p-10'
  };

  const baseClasses = "bg-white rounded-xl";
  const shadowClasses = shadow ? "shadow-sm hover:shadow-md" : "";
  const borderClasses = border ? "border border-gray-100" : "";
  const hoverClasses = hoverable ? "transition-all duration-200 hover:scale-[1.02]" : "";
  const clickableClasses = onClick ? "cursor-pointer" : "";

  const cardClasses = `
    ${baseClasses}
    ${shadowClasses}
    ${borderClasses}
    ${hoverClasses}
    ${clickableClasses}
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <div className={cardClasses} onClick={onClick}>
      {/* Header section */}
      {(header || title || description) && (
        <div className={`${paddingClasses[padding]} ${footer || children ? 'pb-0' : ''}`}>
          {header || (
            <div>
              {title && (
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {title}
                </h3>
              )}
              {description && (
                <p className="text-sm text-gray-600">
                  {description}
                </p>
              )}
            </div>
          )}
        </div>
      )}

      {/* Content section */}
      {children && (
        <div className={paddingClasses[padding]}>
          {children}
        </div>
      )}

      {/* Footer section */}
      {footer && (
        <div className={`${paddingClasses[padding]} pt-0 border-t border-gray-100 bg-gray-50 rounded-b-xl`}>
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;